/**
 * @module app
 */

import { Aurelia, LogManager, PLATFORM } from 'aurelia-framework';
import { AppRouter } from 'aurelia-router';
import { AureliaConfiguration } from 'app/shared/config/aurelia-configuration';
import { AppSession } from 'app/shared/lib/session/session';
import { ConsoleAppender } from "aurelia-logging-console";
import './bundle-hints';
import '../scss/styles.scss';

export async function configure(aurelia: Aurelia): Promise<Aurelia> {
    LogManager.addAppender(new ConsoleAppender());
    LogManager.setLevel(LogManager.logLevel.debug);

    const aureliaConfig = new AureliaConfiguration();
    await aureliaConfig.configure(aurelia);
    aurelia.use.developmentLogging();
    const au = await aurelia.start();

    const session: AppSession = aurelia.container.get(AppSession);
    const authenticated = session.isLoggedIn() && session.isCheckedIn() && !session.isLocked();

    const start = (au as any).host.attributes.start.value;

    aureliaConfig.start();

    return au.setRoot(authenticated ? PLATFORM.moduleName(start) : PLATFORM.moduleName('login'));
}

// INFO [Matt] This is a patch to https://github.com/aurelia/router/issues/465
//  It should be pulled in to a dedicated polyfill section, so that it can be
//  quickly and easily identified and removed once a more official fix lands.
const reset = AppRouter.prototype.reset;
AppRouter.prototype.reset = function(this: any, ...args) {
    reset.call(this, ...args);
    if(this.pipelineProvider) {
        this.pipelineProvider.reset();
    }
}
